export default {
  meta: {
    title: '隐私协议',
  },
};
